function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14712"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 20837",
    style: {
      fill: "#f3f6fa"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 11.5A5.506 5.506 0 0 1 .5 6C.5 2.967 2.967.5 6 .5s5.5 2.467 5.5 5.5-2.467 5.5-5.5 5.5z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 1C3.243 1 1 3.243 1 6s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5m0-1a6 6 0 1 1 0 12A6 6 0 0 1 6 0z",
    style: {
      fill: "#203662",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20834",
    d: "M9.857 4.571h-.428V3.286a1.286 1.286 0 1 0-2.571 0v1.285h-.429A.429.429 0 0 0 6 5v2.571A.429.429 0 0 0 6.429 8h3.428a.429.429 0 0 0 .429-.429V5a.429.429 0 0 0-.429-.429zM7.286 3.286a.857.857 0 1 1 1.714 0v1.285H7.286z",
    transform: "translate(-2.143 1)",
    style: {
      fill: "#203662"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockCircled);
export default __webpack_public_path__ + "static/media/lockCircled.14253cf0ff488d421f01574100c8b92a.svg";
export { ForwardRef as ReactComponent };